angular.module('internal.licenses')
    .directive('internalLicenseHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'licenses/components/license-header/license-header.html',
            controller: 'InternalLicenseHeader',
            replace: true
        };
    }])
    .controller('InternalLicenseHeader', ['$scope', '$filter', function ($scope, $filter) {
        $scope.getDateString = function (opened_date, closed_date) {
            var openedString = $filter('date')(opened_date, 'MM/dd/yyyy hh:mm a');
            var closedString = $filter('date')(closed_date, 'MM/dd/yyyy hh:mm a');
            var dateString = '';

            if (opened_date != null || closed_date != null) {
                if (closed_date == null) {
                    dateString = 'Opens on ' + openedString;
                }
                else if (opened_date == null) {
                    dateString = 'Closes on ' + closedString;
                }
                else {
                    dateString = 'Open from ' + openedString + ' to ' + closedString;
                }
            }
            else {
                dateString = 'No application period set'
            }

            return dateString;
        }
    }])
;